import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.5, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ index, label, title, desc }) => (
  <div className="mb-14 md:mb-20">
    <Reveal>
      <div className="flex items-center gap-4 font-mono text-[11px] font-bold tracking-[0.3em] text-signal">
        <span className="h-2 w-2 bg-signal" />
        <span>
          {index} // {label}
        </span>
        <span className="h-px flex-1 bg-line" />
        <span className="text-slate-600">DOSSIER {index}/05</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-6 font-mono text-4xl font-extrabold uppercase leading-none tracking-tight text-[#F8FAFC] sm:text-5xl lg:text-6xl">
        {title}
      </h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.14}>
        <p className="mt-5 max-w-xl text-sm leading-relaxed text-slate-400 md:text-base">{desc}</p>
      </Reveal>
    )}
  </div>
);

export const Corners = ({ className = "border-signal" }) => (
  <>
    <span className={`absolute left-0 top-0 h-3 w-3 border-l border-t ${className}`} />
    <span className={`absolute right-0 top-0 h-3 w-3 border-r border-t ${className}`} />
    <span className={`absolute bottom-0 left-0 h-3 w-3 border-b border-l ${className}`} />
    <span className={`absolute bottom-0 right-0 h-3 w-3 border-b border-r ${className}`} />
  </>
);
